import type { WorkbookState } from 'cadenza/workbook/workbook.state';
import { isWorkbookVisibilityRestricted } from 'cadenza/workbook/workbook.state';
import { cadenzaSessionStorage } from 'cadenza/utils/storage/storage';
import { parseWorkbookUrl } from 'cadenza/api-client/workbook-api';
import { PARAMETER_OPERATION_MODE } from 'cadenza/api-client/published-api-constants';

const parsedWorkbookUrl = parseWorkbookUrl(location.pathname);
const operationModeKey = parsedWorkbookUrl && `workbook-operation-mode-${parsedWorkbookUrl.workbookIdAndHash.id}`;

export type OperationMode = 'simplified' | 'normal';

export function isOperationModeSimplified (state: WorkbookState) {
  return getOperationMode(state) === 'simplified';
}

function getOperationMode (state: WorkbookState) {
  if (isWorkbookVisibilityRestricted(state)) {
    return 'simplified';
  }
  return loadOperationMode() ?? 'normal';
}

function loadOperationMode () {
  return (new URLSearchParams(location.search).get(PARAMETER_OPERATION_MODE)
    ?? (operationModeKey && cadenzaSessionStorage.getItem(operationModeKey))) as OperationMode | undefined
    ?? undefined;
}

export function saveOperationMode (state: WorkbookState, operationMode = getOperationMode(state)) {
  if (!operationModeKey) {
    return;
  }
  // Safety check, if user has visibility restricted, then he cannot set 'normal' operation mode
  if (isWorkbookVisibilityRestricted(state)) {
    operationMode = 'simplified';
  }
  cadenzaSessionStorage.setItem(operationModeKey, operationMode);
}
